import React, { useEffect, useState } from "react";
import styles from "../../../../styles/scope3/Dashboard/transportation.module.css";
import { durationObj, monthSort } from "../../../../utils/constant";
import LineChart from "../../../../Components/GraphNCharts/LineChart";
import BarChart from "../../../../Components/GraphNCharts/BarChart";
import GlobalChart from "../../../../Components/GraphNCharts/GlobalChart";
import TableChart from "../../../../Components/GraphNCharts/TableChart";
import EchartDoughnutChart from "../../../../Components/GraphNCharts/EchartDoughnut";
import { get } from "../../../../utils/api";
import { Box, Typography } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import EmittingTableChart from "./EmittingTableChart";
import CarbonIntensity from "./CarbonIntensity";
import FuelConsumption from "./FuelConsumption";
import EmissionLineChart from "./EmissionLineChart";
import {
  fixedPercentage,
  fixedTons,
  formatNumberCommaSeparated,
  generateYearList,
} from "../../../../utils/common";
import PeriodFilter from "../../../../Components/Common/PeriodFilter";
import useAuthStore from "../../../../store/ContextUser";

const Dashboard = () => {
  const { selectedCompany }=useAuthStore();
  const [month, setMonth] = useState("1M");
  const [year, setYear] = useState("1M");
  const [emission, setEmission] = useState([]);
  const [emissionByStream, setEmissionByStream] = useState([]);
  const [fuelConsumption, setFuelConsumption] = useState([]);
  const [efficiencyMetrices, setEfficiencyMetrices] = useState(0);
  const [freight, setFreight] = useState([]);
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // Add 1 because months are 0-based
  const currentYear = currentDate.getFullYear();
  const [selectedFacility, setSelectedFacility] = useState([]);
  const [tableData, setTableData] = useState();
  const [travelData, setTravelData] = useState();
  const [roadTravelData, setRoadTravelData] = useState();
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });
  const [shipment, setShipment] = useState([]);
  const [waterEmission, setWaterEmission] = useState([]);
  const [roadCarbon, setRoadCarbon] = useState([]);
  const [roadCarbonFilter, setRoadCarbonFilter] = useState("Distance");
  const [shipCarbon, setShipCarbon] = useState([]);
  const [shipCarbonFilter, setShipCarbonFilter] = useState("Distance");
  const [railCarbon, setRailCarbon] = useState([]);
  const [railCarbonFilter, setRailCarbonFilter] = useState("Distance");
  const [airCarbon, setAirCarbon] = useState([]);
  const [airCarbonFilter, setAirCarbonFilter] = useState("Distance");
  const [trendFilter, setTrendFilter] = useState("Annual");
  const [emissionFilter, setEmissionFilter] = useState({
    Road: "Annual",
    Air: "Annual",
    Rail: "Annual",
    Ship: "Annual",
  });
  const [streamEmissionFilter, setStreamEmissionFilter] = useState({
    Road: "Annual",
    Air: "Annual",
    Rail: "Annual",
    Ship: "Annual",
  });
  const [shipmentCategoryFilter, setShipmentCategoryFilter] =
    useState("Dry Shipment");
  const [totalTrips, setTotalTrips] = useState({});
  const [roadTransport, setRoadTransport] = useState({});
  const [roadTransportFilter, setRoadTransportFilter] = useState("Annual");

  // useEffect(() => {
  //   const currentDate = new Date();
  //   setMonth(String(currentDate.getMonth() + 1).padStart(2, "0"));
  //   setYear(currentDate.getFullYear());
  // }, []);

  useEffect(() => {
    fetchEmission();
    fetchEmissionByStream();
    fetchFuelConsumption();
    fetchRoadTransport();
    fetchWaterEmission();
    fetchTotalTrips();
    fetchRoadCarbon();
    fetchShipCarbon();
    fetchRailCarbon();
    fetchAirCarbon();
    // fetchAirEmission();
  }, [fromDate, toDate, selectedFacility,selectedCompany]);

  useEffect(() => {
    fetchFreight();
  }, [fromDate, toDate,selectedCompany]);

  const yearList = generateYearList(2020);

  const fetchGlobalData = async () => {
    try {
      let response = await get(
        `dashboard/globalEmission/trasnportionAndDistributionMap?timeFrame=${month}&companyId=${selectedCompany?._id}`
      );
      setTableData(response?.data?.data);
      console.log("first45", response?.data?.data);
    } catch (error) {}
  };

  useEffect(() => {
    fetchGlobalData();
  }, [month,selectedCompany]);

  const fetchGlobalTravelData = async () => {
    try {
      let response = await get(
        `dashboard/globalEmission/transportation/top5Emission?timeFrame=${month}&companyId=${selectedCompany?._id}`
      );
      setTravelData(response?.data?.top5Emissions);
    } catch (error) {}
  };

  useEffect(() => {
    fetchGlobalTravelData();
  }, [month,selectedCompany]);

  const fetchRoadTravelData = async () => {
    try {
      let response = await get(
        `dashboard/globalEmission/transportation/road/top5Emission?timeFrame=${year}&companyId=${selectedCompany?._id}`
      );
      setRoadTravelData(response?.data?.top5Emissions);
    } catch (error) {}
  };

  useEffect(() => {
    fetchRoadTravelData();
  }, [year,selectedCompany]);

  const fetchEmission = async () => {
    try {
      const res2 = await get(
        `/dashboard/scope3/transportation/emission?startYear=${
          fromDate.year
        }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
          toDate.month
        }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
      );
      setEmission(res2?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchEmissionByStream = async () => {
    try {
      const res2 = await get(
        `/dashboard/scope3/transportation/emissionByupStreamAndDownStreamTransportation?startYear=${
          fromDate.year
        }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
          toDate.month
        }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
      );
      console.log(res2?.data);
      setEmissionByStream(res2?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchFuelConsumption = async () => {
    try {
      const res = await get(
        `/dashboard/scope3/transportation/fuelConsumptionByTranportionType?startYear=${
          fromDate.year
        }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
          toDate.month
        }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
      );
      console.log(res?.data, "fuel");
      setFuelConsumption(res?.data);
    } catch (error) {
      console.log(error);
    }
  };

  console.log(
    emissionByStream?.map((emission) =>
      emission?.twelveMonthData
        ?.map((stream, i) =>
          stream?.monthlyData?.map((e) => e?.emission)?.filter(Boolean)
        )
        ?.filter(Boolean)
    ),
    "print"
  );
  const streamEmissionDataset = emissionByStream?.map((emission) => {
    const allEmissions = emission?.twelveMonthData?.flatMap((stream) =>
      stream?.monthlyData?.map((e) => e?.emission).filter(Boolean)
    );

    return {
      [emission?.emission]:
        allEmissions?.length > 0
          ? emission?.twelveMonthData?.map((stream) => ({
              label: stream?.category,
              data: stream?.monthlyData?.map((e) => e?.emission) || [],
              borderColor: stream?.category === "Upstream" ? "blue" : "red",
              backgroundColor: stream?.category === "Upstream" ? "blue" : "red",
              tension: 0.4,
              fill: true,
              pointRadius: 0,
            }))
          : [],
    };
  });

  const streamEmissionDataset2 = emissionByStream?.map((emission) => {
    const allEmissions = emission?.tenYearData?.flatMap((stream) =>
      stream?.monthlyData?.map((e) => e?.emission).filter(Boolean)
    );

    return {
      [emission?.emission]:
        allEmissions?.length > 0
          ? emission?.tenYearData?.map((stream) => ({
              label: stream?.category,
              data: stream?.yearlyData?.map((e) => e?.emission) || [],
              borderColor: stream?.category === "Upstream" ? "blue" : "red",
              backgroundColor: stream?.category === "Upstream" ? "blue" : "red",
              tension: 0.4,
              fill: true,
              pointRadius: 0,
            }))
          : [],
    };
  });

  const streamDataset = emissionByStream?.map((el, i) => ({
    emission: el?.emission || 0,
    value: Number(el?.value) || 0,
    annualValue: el?.annualDataSum || 0,
    yearValue: el?.yearDataSum || 0,
    yearSort: el?.tenYearData?.map((e) =>
      e?.yearlyData?.map((year) => year?.year)
    )[0],
    monthLabel:
      el?.twelveMonthData?.[0]?.monthlyData?.map(
        (e) => monthSort[e?.month - 1] + "'" + e?.year.toString().slice(-2)
      ) || [],
    percentageDifference: el?.percentageDifference || 0,
    dataset: streamEmissionDataset[i][el?.emission],
    dataset2: streamEmissionDataset2[i][el?.emission],
  }));

  useEffect(() => {
    const fetchEfficiencyMetrices = async () => {
      try {
        const res = await get(
          `/dashboard/scope3/transportation/efficiencyMetrics?startYear=${
            fromDate.year
          }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
            toDate.month
          }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
        );
        setEfficiencyMetrices(res?.data?.totalEmissionPerKm);
      } catch (error) {
        console.log(error);
      }
    };
    fetchEfficiencyMetrices();
  }, [fromDate?.month, fromDate?.year, toDate?.month, toDate?.year,selectedCompany]);

  const fetchFreight = async () => {
    try {
      const res = await get(
        `/dashboard/scope3/transportation/freight-metrics?startYear=${
          fromDate.year
        }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
          toDate.month
        }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
      );
      console.log(res?.data?.data, "freight");
      const freightData = [
        {
          key: "totalFreightLoad",
          percentageKey: "loadPercentage",
          title: "Total Freight Load (Tonnes)",
          dataKey: "totalFreightLoad",
        },
        {
          key: "totalDistanceTraveled",
          title: "Total Distance Covered (Km)",
          dataKey: "totalDistanceTraveled",
        },
      ];

      setFreight(
        freightData.map(({ key, percentageKey, title, dataKey }) => ({
          total: res?.data?.[key],
          percentageDifference: percentageKey
            ? res?.data?.[percentageKey]
            : undefined,
          title,
          labels: res?.data?.data?.map((el) => el?.type),
          dataSet:
            res?.data?.data?.map((el) => el?.data?.[dataKey])?.filter(Boolean)
              ?.length > 0
              ? [
                  {
                    data: res?.data?.data?.map((el) => el?.data?.[dataKey]),
                    borderColor: "#0051B7",
                    backgroundColor: "#0051B7",
                    tension: 0.4,
                    fill: true,
                    pointBorderColor: "#fff",
                    pointRadius: 0,
                  },
                ]
              : [],
        }))
      );
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTotalTrips = async () => {
    try {
      const res = await get(
        `/dashboard/scope3/transportation/road/trip-status?startYear=${
          fromDate.year
        }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
          toDate.month
        }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
      );
      const totalTripsColors = ["#3CD715", "#FF4F4F", "#9200B7", "#0E62E0"];
      const totalTripsLabels = [
        "Completed",
        "Cancelled",
        "Pending",
        "In Progress",
      ];
      setTotalTrips({
        total: formatNumberCommaSeparated(res?.data?.totalTrips),
        labels: res?.data?.data?.[0]?.data?.map(
          (el) => monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
        ),
        totalTrips: totalTripsLabels?.map((el, i) => ({
          label: el === "Pending" ? "Yet to Start" : el,
          data: res?.data?.data
            ?.find((e, i) => e?.tripStatus === el)
            ?.data?.map((trip) => trip?.totalCount),
          borderColor: totalTripsColors[i],
          backgroundColor: totalTripsColors[i],
          tension: 0.4,
          fill: true,
          pointBorderColor: "#fff",
          pointRadius: 0,
        })),
      });
    } catch (error) {
      console.log(error);
    }
  };

  // useEffect(() => {
  //   fetchRoadTransport();
  // }, []);

  const fetchRoadTransport = async () => {
    try {
      const res = await get(
        `/dashboard/scope3/transportation/getRoadEmissionByVehicleType?startYear=${
          fromDate.year
        }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
          toDate.month
        }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
      );
      console.log(
        res?.data,
        "road1",
        res?.data?.yearlyData?.[0]?.data?.map((el) => el?.year)
      );

      const colors = ["#3CD715", "#FF4F4F", "#9200B7", "#0E62E0"];
      setRoadTransport({
        yearList: res?.data?.yearlyData?.[0]?.data?.map((el) => el?.year),
        tenYearTotal: fixedTons(res?.data?.lastTenYearsSum) || 0,
        yearlyData: res?.data?.yearlyData?.map((el, i) => ({
          label: el?._id,
          data: el?.data?.map((e) => e?.emission),
          borderColor: colors[i],
          backgroundColor: colors[i],
          tension: 0.4,
          fill: true,
          pointBorderColor: "#fff",
          pointRadius: 0,
        })),
        oneYearTotal: fixedTons(res?.data?.currentYearSum) || 0,
        monthlyData: res?.data?.monthlyData?.map((el, i) => ({
          label: el?._id,
          data: el?.data?.map((e) => e?.emission),
          borderColor: colors[i],
          backgroundColor: colors[i],
          tension: 0.4,
          fill: true,
          pointBorderColor: "#fff",
          pointRadius: 0,
        })),
        monthLabels: res?.data?.monthlyData?.[0]?.data?.map(
          (el) => monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
        ),
      });
      console.log(roadTransport, res?.data, "road1");
    } catch (error) {
      console.log(error);
    }
  };

  const fetchWaterEmission = async () => {
    try {
      const res = await get(
        `/dashboard/scope3/transportation/water/emission?startYear=${
          fromDate.year
        }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
          toDate.month
        }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
      );

      setWaterEmission(res?.data);
      setShipment(
        [
          fixedTons(
            res?.data?.emissionsByCategory?.find(
              (el) =>
                el?.categoryOfShipment === "Liquid Shipment" &&
                el?.totalEmission
            )?.totalEmission || 0
          ),
          fixedTons(
            res?.data?.emissionsByCategory?.find(
              (el) =>
                el?.categoryOfShipment === "Dry Shipment" && el?.totalEmission
            )?.totalEmission || 0
          ),
        ]?.filter(Boolean)
      );
      console.log(res?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRoadCarbon = async () => {
    try {
      const res = await get(
        `/dashboard/scope3/transportation/roadCardbonIntensityDistancevsLoad?startYear=${
          fromDate.year
        }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
          toDate.month
        }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
      );
      setRoadCarbon(res?.data?.roadEmissionData);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchShipCarbon = async () => {
    try {
      const res = await get(
        `/dashboard/scope3/transportation/shipCardbonIntensityDistancevsLoad?startYear=${
          fromDate.year
        }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
          toDate.month
        }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
      );
      setShipCarbon(res?.data?.shipEmissionData);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRailCarbon = async () => {
    try {
      const res = await get(
        `/dashboard/scope3/transportation/railCardbonIntensityDistancevsLoad??startYear=${
          fromDate.year
        }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
          toDate.month
        }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
      );
      setRailCarbon(res?.data?.railEmissionData);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAirCarbon = async () => {
    try {
      const res = await get(
        `/dashboard/scope3/transportation/airCardbonIntensityDistancevsLoad?startYear=${
          fromDate.year
        }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
          toDate.month
        }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
      );
      setAirCarbon(res?.data?.airEmissionData);
    } catch (error) {
      console.log(error);
    }
  };

  const roadColors = ["#0E62E0", "#9200B7", "#FF4F4F", "#3CD715", "#FFBB33"];
  const roadLabels = ["Trucks", "Cars", "Buses", "Vans", "Bike"];
  // const roadValues = [40, 20, 40, 60, 76];

  let roadDataSet = roadLabels?.map((el, i) => ({
    label: el,
    data: [10, 30, 50, 10, 30, 10, 20, 30, 30, 10, 20, 30],
    borderColor: roadColors[i],
    backgroundColor: roadColors[i],
    tension: 0.4,
    fill: true,
    pointBorderColor: "#fff",
    pointRadius: 0,
  }));

  const extractShipmentCategory = (shipmentCategory) => {
    const res = waterEmission?.emissionByType?.currentYearData?.find(
      (shipment) => shipment?.categoryOfShipment === shipmentCategory
    )?.shipmentTypes;

    console.log(res, "res", shipmentCategory);
    return res;
  };

  const createLinechartDataset = (labels, colors, data) => {
    const dataSet = labels?.map((el, i) => ({
      label: el,
      data: labels?.length > 1 ? data[i] : data,
      borderColor: colors[i],
      backgroundColor: colors[i],
      tension: 0.4,
      fill: true,
      pointBorderColor: "#fff",
      pointRadius: 0,
    }));
    console.log(";ine", dataSet, data, colors, labels);
    return dataSet;
  };

  console.log("first12", streamDataset, streamEmissionFilter);

  const emissionData =
    trendFilter === "Annual"
      ? emission?.map((el) =>
          el?.twelveMonthData?.map((e) => e?.totalEmission)?.filter(Boolean)
        )
      : emission?.map((el) =>
          el?.tenYearData?.map((e) => e?.totalEmission)?.filter(Boolean)
        );

  const lineChartDataset =
    emissionData?.filter((data) => data?.length > 0)?.length > 0
      ? createLinechartDataset(
          emission?.map((el) => el?.emission),
          ["#FF4F4F", "#9200B7", "#0E62E0", "#3CD715"],
          trendFilter === "Annual"
            ? emission?.map((el) =>
                el?.twelveMonthData?.map((e) => e?.totalEmission)
              )
            : emission?.map((el) =>
                el?.tenYearData?.map((e) => e?.totalEmission)
              )
        )
      : [];

  const shipmentData =
    shipmentCategoryFilter === "Dry Shipment"
      ? extractShipmentCategory("Dry Shipment")
      : extractShipmentCategory("Liquid Shipment");

  const shipmentEmissions = shipmentData
    ?.map((e) =>
      e?.monthlyData?.map((data) => data?.totalEmission)?.filter(Boolean)
    )
    ?.filter((arr) => arr?.length > 0); // ✅ filter only non-empty arrays

  console.log(shipmentEmissions, "ship2");

  const shipmentDataset =
    shipmentEmissions?.length > 0
      ? createLinechartDataset(
          shipmentData?.map((e) => e?.typeOfShipment),
          [
            "#0E62E0",
            "#9200B7",
            "#FF4F4F",
            "#3CD715",
            "#FFBB33",
            "#0051B7",
            "",
          ],
          shipmentData?.map((e) =>
            e?.monthlyData?.map((data) => data?.totalEmission)
          )
        )
      : [];

  const shipmentLabels =
    waterEmission?.emissionByType?.currentYearData?.[0]?.shipmentTypes?.[0]?.monthlyData?.map(
      (el) => monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
    );

  const shipColors = ["#0051B7", "#9200B7"];
  return (
    <>
      <div className={styles.heading_container}>
        <p className={styles.heading}>Transportation and Distribution</p>
        {/* Date Filter */}
        <PeriodFilter
          {...{
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            yearList,
            setSelectedFacility,
            selectedFacility,
          }}
        />
      </div>

      <p className={styles.section_heading}>Emissions Analysis</p>
      <EmissionLineChart
        title={"Total Emissions by mode of transport"}
        {...{
          emission,
          emissionFilter,
          setEmissionFilter,
          createLinechartDataset,
        }}
      />

      {/* Emission Hotspot */}
      <div
        className={styles.world_map_container}
        style={{ marginTop: "1.5rem" }}
      >
        <div className={styles.world_map_heading_container}>
          <p className={styles.emission_heading}>Emission Hotspot</p>
          <div style={{ display: "flex", gap: "12px" }}>
            <select
              name="month"
              id="month"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              className={styles.heading_select_month}
            >
              {durationObj?.map((m) => (
                <option key={m?.id} value={m?.id}>
                  {m?.label}
                </option>
              ))}
            </select>

            {/* <select
              name="year"
              id="year"
              value={year}
              onChange={(e) => setYear(e.target.value)}
              className={styles.heading_select_year}
            >
              {["World"].map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select> */}
          </div>
        </div>
        <div className={styles.world_map_data}>
          <div className={styles.world_map_table} style={{ width: "100%" }}>
            <EmittingTableChart tableData={travelData} />
          </div>
          {/* <div className={styles.world_map_chart}>
            <GlobalChart tableData={travelData} />
          </div> */}
        </div>
      </div>

      {/* Emissions by Upstream vs Downstream Transport */}
      <EmissionLineChart
        display={true}
        title={"Emissions by Upstream vs Downstream Transport"}
        {...{
          emission: streamDataset,
          emissionFilter: streamEmissionFilter,
          setEmissionFilter: setStreamEmissionFilter,
        }}
        lineTitle={"stream"}
      />

      {/* Efficiency Analysis */}
      <p className={styles.card_heading}>Efficiency Metrics</p>
      <Box
        sx={{
          height: "7rem",
          width: "48.5%",
          borderRadius: "12px",
          padding: "1.5rem",
          backgroundColor: "rgba(252, 252, 252, 1)",
        }}
      >
        <p className={styles.emission_heading}>
          Total Emissions per Km Travelled (tCO2e)
        </p>
        <p className={styles.card_heading}>
          {formatNumberCommaSeparated(fixedTons(efficiencyMetrices ?? 0))}
        </p>
      </Box>

      {/* Freight Metrices */}
      <p className={styles.card_heading}>Freight Metrics</p>
      <div className={styles.freight_container}>
        {freight?.map((el) => (
          <div
            className={styles.diversity_container}
            style={{ padding: "1.5rem" }}
          >
            <p className={styles.emission_heading}>
              {el?.title} :
              <span className={styles.emission_heading_span}>
                {formatNumberCommaSeparated(fixedTons(el?.total))}{" "}
              </span>
              {el?.percentageDifference && (
                <span
                  className={styles.emission_heading_percent}
                  style={{
                    color: el?.percentageDifference >= 0 ? "#00C851" : "red",
                  }}
                >
                  ({el?.percentageDifference >= 0 ? "+" : "-"}
                  {fixedPercentage(el?.percentageDifference ?? 0)}% YOY{" "}
                  {el?.percentageDifference >= 0 ? (
                    <TrendingUpIcon sx={{ fontSize: "18px" }} />
                  ) : (
                    <TrendingDownIcon sx={{ fontSize: "18px" }} />
                  )}
                  )
                </span>
              )}
            </p>
            <BarChart
              datasets={el?.dataSet}
              labels={el?.labels}
              yAxisTitle={"Load in Tonnes"}
              customWidth={410}
              customHeight={250}
            />
          </div>
        ))}
      </div>

      {/* Mode Specific Analysis */}
      <p className={styles.card_heading}>Mode-Specific Analytics</p>
      <p className={styles.mode_specific_heading}>1. Road Transportation </p>
      <div className={styles.cards}>
        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "space-between",
          }}
        >
          <p className={styles.emission_heading}>
            Total Emission by Vehicle Type (tCO2e) :
            <span className={styles.emission_heading_span}>
              {roadTransportFilter === "Annual"
                ? formatNumberCommaSeparated(
                    fixedTons(roadTransport?.oneYearTotal)
                  )
                : formatNumberCommaSeparated(
                    fixedTons(roadTransport?.tenYearTotal)
                  )}
            </span>
          </p>
          <div>
            <Typography style={{ fontSize: "12px", marginBottom: "-0.5" }}>
              Filter by :
            </Typography>
            <select
              name="Transport Type"
              id="month"
              value={roadTransportFilter}
              style={{ width: "8rem" }}
              onChange={(e) => setRoadTransportFilter(e.target.value)}
              className={styles.heading_select_month}
            >
              {/* <option value="All">All</option> */}
              {["Annual", "Year On Year"].map((m) => (
                <option key={m} value={m}>
                  {m}
                </option>
              ))}
            </select>
          </div>
        </div>
        <BarChart
          datasets={
            roadTransportFilter === "Annual"
              ? roadTransport?.monthlyData
              : roadTransport?.yearlyData
          }
          labels={
            roadTransportFilter === "Annual"
              ? roadTransport?.monthLabels
              : roadTransport?.yearList
          }
          customWidth={"100%"}
          customHeight={300}
          display={true}
          yAxisTitle={"Emissions (tCO2e)"}
        />
      </div>

      {/* Top Emitting Routes */}
      <div
        className={styles.world_map_container}
        style={{ marginTop: "1.5rem" }}
      >
        <div className={styles.world_map_heading_container}>
          <p className={styles.emission_heading}>Top Emitting Routes</p>
          <div style={{ display: "flex", gap: "12px" }}>
            <select
              name="year"
              id="year"
              value={year}
              onChange={(e) => setYear(e.target.value)}
              className={styles.heading_select_year}
              style={{ width: "140px" }}
            >
              {durationObj?.map((m) => (
                <option key={m?.id} value={m?.id}>
                  {m?.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <EmittingTableChart tableData={roadTravelData} />
      </div>

      {/* Fuel Consumption */}
      <div className={styles.freight_container} style={{ marginTop: "1.5rem" }}>
        <FuelConsumption data={fuelConsumption?.roadData} />
        {/* Road Carbon */}
        <CarbonIntensity
          filter={roadCarbonFilter}
          setFilter={setRoadCarbonFilter}
          carbon={roadCarbon}
        />
      </div>

      {/* Total Trips */}
      <div className={styles.cards} style={{ marginTop: "1.5rem" }}>
        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "space-between",
          }}
        >
          <p className={styles.emission_heading}>
            Total Trips :{" "}
            <span className={styles.emission_heading_span}>
              {formatNumberCommaSeparated(
                fixedPercentage(totalTrips?.total ?? 0)
              )}
            </span>
          </p>
        </div>

        <BarChart
          datasets={totalTrips?.totalTrips}
          labels={totalTrips?.labels}
          customWidth={"100%"}
          customHeight={300}
          display={true}
          yAxisTitle={"Emissions (tCO2e)"}
        />
      </div>

      {/* Ship */}
      <p className={styles.mode_specific_heading} style={{ marginTop: "1rem" }}>
        2. Ship :{" "}
      </p>
      <div className={styles.cards}>
        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "space-between",
          }}
        >
          <p className={styles.emission_heading}>
            Emission by Shipment Type (tCO2e) :{" "}
            <span className={styles.emission_heading_span}>
              {formatNumberCommaSeparated(
                fixedTons(
                  waterEmission?.emissionsByCategory?.find(
                    (e) => e?.categoryOfShipment === shipmentCategoryFilter
                  )?.totalEmission ?? 0
                )
              )}
            </span>
          </p>
          <div>
            <Typography style={{ fontSize: "12px", marginBottom: "-0.5" }}>
              Shipment Category
            </Typography>
            <select
              name="categoryOfShipment"
              id="month"
              value={shipmentCategoryFilter}
              onChange={(e) => setShipmentCategoryFilter(e.target.value)}
              className={styles.heading_select_month}
              style={{ width: "9.5rem" }}
            >
              {["Dry Shipment", "Liquid Shipment"].map((m) => (
                <option key={m} value={m}>
                  {m}
                </option>
              ))}
            </select>
          </div>
        </div>
        <BarChart
          datasets={shipmentDataset}
          labels={shipmentLabels}
          customWidth={"100%"}
          customHeight={300}
          display={true}
          yAxisTitle={"Emissions (tCO2e)"}
        />
      </div>

      {/* Emission by Shipment Category */}
      <div className={styles.freight_container} style={{ marginTop: "1.5rem" }}>
        <div className={styles.cards} style={{ width: "100%" }}>
          <div style={{ width: "100%" }}>
            <p className={styles.emission_heading}>
              Emission by Shipment Category (tCO2e) :{" "}
              <span className={styles.emission_heading_span}>
                {formatNumberCommaSeparated(
                  fixedTons(shipment.reduce((el, acc) => acc + el, 0))
                )}
              </span>
            </p>
          </div>
          {shipment?.length > 0 ? (
            <Box sx={{ display: "flex", gap: 1, mt: 4 }}>
              <Box sx={{ width: "80%", ml: "-1.5rem" }}>
                <EchartDoughnutChart
                  labels={["Liquid", "Dry"]}
                  dataPoints={shipment}
                  colors={shipColors?.map((el) => el)}
                  customWidth={280}
                  customHeight={250}
                />
              </Box>
              <div style={{ marginTop: "25%", width: "50%" }}>
                {["Liquid", "Dry"].map((item, index) => (
                  <div key={index} className={styles.table_container}>
                    <div className={styles.table_row}>
                      <span
                        className={styles.table_row_label}
                        style={{
                          backgroundColor: shipColors[index],
                        }}
                      ></span>
                      <span className={styles.table_text}>{item}</span>
                    </div>
                    <span className={styles.table_text}>{shipment[index]}</span>
                  </div>
                ))}
              </div>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center", // horizontally center
                alignItems: "center", // vertically center
                height: "18rem", // ensure it takes up space
                width: "100%", // optional, to match parent
              }}
            >
              <Typography
                sx={{
                  fontSize: "24px",
                  fontFamily: "inter",
                  color: "#d3d3d3",
                  fontWeight: "bold",
                }}
              >
                No Data Found
              </Typography>
            </Box>
          )}
        </div>
        {/* Water carbon Intensity */}
        <CarbonIntensity
          filter={shipCarbonFilter}
          setFilter={setShipCarbonFilter}
          carbon={shipCarbon}
        />
      </div>

      {/* 3. Rail */}
      <p className={styles.mode_specific_heading} style={{ marginTop: "1rem" }}>
        3. Rail :{" "}
      </p>
      <div className={styles.freight_container} style={{ marginTop: "1rem" }}>
        <FuelConsumption data={fuelConsumption?.railData} />
        {/* Rail Carbon Intensity */}
        <CarbonIntensity
          filter={railCarbonFilter}
          setFilter={setRailCarbonFilter}
          carbon={railCarbon}
        />
      </div>

      {/* 4. Air */}
      <p className={styles.mode_specific_heading} style={{ marginTop: "1rem" }}>
        4. Air :{" "}
      </p>
      <div className={styles.freight_container} style={{ marginTop: "1rem" }}>
        <FuelConsumption data={fuelConsumption?.airData} />
        {/* Air Carbon Intensity */}
        <CarbonIntensity
          filter={airCarbonFilter}
          setFilter={setAirCarbonFilter}
          carbon={airCarbon}
        />
      </div>

      <p className={styles.section_heading} style={{ marginTop: "1rem" }}>
        Comparative Insight
      </p>
      <div
        className={styles.comparative_container}
        style={{ marginTop: "1rem" }}
      >
        <div className={styles.cards}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: "4rem",
            }}
          >
            <div>
              <p className={styles.emission_heading}>
                Trend of Emissions Over Time
              </p>
            </div>
            <div>
              <Typography style={{ fontSize: "12px", marginBottom: "-0.5" }}>
                Filter By :
              </Typography>
              <select
                name={"trendFilter"}
                id="month"
                value={trendFilter}
                onChange={(e) => setTrendFilter(e.target.value)}
                className={styles.heading_select_month}
                style={{ width: "7.5rem" }}
              >
                {["Annual", "Year On Year"].map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
            </div>
          </Box>

          {/* --- Main Data Logic --- */}

          <LineChart
            dataset={lineChartDataset}
            labels={
              trendFilter === "Annual"
                ? emission[0]?.twelveMonthData?.map(
                    (el) =>
                      monthSort[el?.month - 1] +
                      "'" +
                      el?.year.toString().slice(-2)
                  )
                : emission[0]?.tenYearData?.map((e) => e?.year)
            }
            display={true}
            yAxisTitle={"Emissions (tCO2e)"}
            customWidth="100%"
            customHeight={300}
          />
        </div>
      </div>

      {/* Emission Map */}
      <div
        className={styles.world_map_container}
        style={{ marginTop: "1.5rem" }}
      >
        <div className={styles.world_map_heading_container}>
          <p className={styles.emission_heading}>
            Emission Map (country - Facility)
          </p>
          <div style={{ display: "flex", gap: "12px" }}>
            <select
              name="month"
              id="month"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              className={styles.heading_select_month}
            >
              {durationObj?.map((m) => (
                <option key={m?.id} value={m?.id}>
                  {m?.label}
                </option>
              ))}
            </select>

            {/* <select
              name="year"
              id="year"
              value={year}
              onChange={(e) => setYear(e.target.value)}
              className={styles.heading_select_year}
            >
              {["World"].map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select> */}
          </div>
        </div>
        <div className={styles.world_map_data}>
          <div className={styles.world_map_table}>
            <TableChart tableData={tableData} />
          </div>
          <div className={styles.world_map_chart}>
            <GlobalChart tableData={tableData} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
